export const scanType = Object.freeze([
  { id: 'Survey', name: 'Survey (Schouw)' },
  { id: 'OpenTrench', name: 'Open Trench (Open geul)' },
  { id: 'Final', name: 'Final (Afgerond)' },
]);
